import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { forwardRef } from '@vectord/components';

import styles from './TableBody.module.scss';

function TableBody({ children, className, forwardedRef, ...remainingProps }) {
  return (
    <tbody
      ref={forwardedRef}
      className={classNames(styles.root, className)}
      {...remainingProps}
    >
      {children}
    </tbody>
  );
}

TableBody.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default forwardRef(TableBody);
